import { render, staticRenderFns } from "./StepPasswordCheck.vue?vue&type=template&id=0b5557e0&"
import script from "./StepPasswordCheck.vue?vue&type=script&lang=ts&"
export * from "./StepPasswordCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports